import React, { Fragment, useRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      content = _ref.content,
      placement = _ref.placement;
  var tooltipRef = useRef();
  var tooltipTriggerRef = useRef();

  var _useState = useState(false),
      isHovered = _useState[0],
      setHover = _useState[1];

  var handleMouseEnter = function handleMouseEnter() {
    setHover(true);
  };

  var handleMouseLeave = function handleMouseLeave() {
    setTimeout(function () {
      setHover(false);
    }, 250);
  };

  useEffect(function () {
    var $tooltipTrigger = tooltipTriggerRef.current;

    if ($tooltipTrigger) {
      $tooltipTrigger.addEventListener('mouseenter', handleMouseEnter, false);
      $tooltipTrigger.addEventListener('mouseleave', handleMouseLeave, false);
    }

    return function () {
      if ($tooltipTrigger) {
        $tooltipTrigger.removeEventListener('mouseenter', handleMouseEnter, false);
        $tooltipTrigger.removeEventListener('mouseleave', handleMouseLeave, false);
      }
    };
  }, []);

  var renderTooltip = function renderTooltip() {
    var $tooltip = tooltipRef.current;
    var $tooltipTrigger = tooltipTriggerRef.current;
    var rect = $tooltipTrigger.getBoundingClientRect();
    $tooltip.classList.add("tooltip--" + placement); // Grab dimensions of link

    var linkDim = {
      w: rect.width,
      h: rect.height
    }; // Tooltip dimensions

    var tooltipDim = {
      w: $tooltip.offsetWidth,
      h: $tooltip.offsetHeight
    };
    var scrollYOffset = window.pageYOffset || document.documentElement.scrollTop;
    var scrollXOffset = window.pageXOffset || document.documentElement.scrollLeft; // eslint-disable-next-line default-case

    switch (placement // eslint-disable-line default-case
    ) {
      case 'top':
        $tooltip.style.top = rect.top + scrollYOffset - tooltipDim.h + "px";
        $tooltip.style.left = rect.left + scrollXOffset + linkDim.w / 2 - tooltipDim.w / 2 + "px";
        $tooltip.style.transformOrigin = 'center bottom';
        break;

      case 'bottom':
        $tooltip.style.top = rect.top + scrollYOffset + linkDim.h + "px";
        $tooltip.style.left = rect.left + scrollXOffset + linkDim.w / 2 - tooltipDim.w / 2 + "px";
        $tooltip.style.transformOrigin = 'center top';
        break;

      case 'left':
        $tooltip.style.top = rect.top + scrollYOffset + linkDim.h / 2 - tooltipDim.h / 2 + "px";
        $tooltip.style.left = rect.left + scrollXOffset - tooltipDim.w + "px";
        $tooltip.style.transformOrigin = 'right center';
        break;

      case 'right':
        $tooltip.style.top = rect.top + scrollYOffset + linkDim.h / 2 - tooltipDim.h / 2 + "px";
        $tooltip.style.left = rect.left + scrollXOffset + linkDim.w + "px";
        $tooltip.style.transformOrigin = 'left center';
        break;
    }
  };

  var renderChildren = React.Children.map(children, function (child) {
    return React.cloneElement(child, {
      ref: tooltipTriggerRef
    });
  });
  useUpdateEffect(function () {
    if (isHovered) {
      renderTooltip();
    }
  }, [isHovered]);
  return React.createElement(Fragment, null, renderChildren, isHovered && ReactDOM.createPortal(React.createElement("div", {
    className: "tooltip",
    ref: tooltipRef,
    role: "tooltip"
  }, React.createElement("div", {
    className: "tooltip-inner"
  }, content)), document.body));
};

Tooltip.defaultProps = {
  placement: 'top'
};
export default Tooltip;